import { useContext, useEffect, useState } from 'react'
import DynamicDownloadBtnSection from '../../../../components/DynamicDownloadBtnSection/DynamicDownloadBtnSection'
import { AppContext } from '../../../../context/AppContext'
import "./CalendarHandbook.scss";
import axios from 'axios';
import { toast } from 'react-toastify';

const CalendarHandbook = () => {

    const { backendUrl } = useContext(AppContext);
    const [allCalendarHandbooks, setAllCalendarHandbook] = useState([]);
     let errorShown = false;

      async function fetchAllCalendarHandbooks() {
        try {
            const { data } = await axios.get(`${backendUrl}/api/auth/getAllCalendarHandbooks`);
            if (data.success) {
                setAllCalendarHandbook(data || []);
            } 
            errorShown = false;  
        } catch (error) {
            if (errorShown) return;
            errorShown = true;
            if (error.response && error.response.status === 503) {
                            toast.error("⚠️ The service is currently under maintenance. Please try again later.");
                        }
                        else if (!navigator.onLine) {
                            toast.error("🚫 No internet connection. Please check your network.");
                        }
            
                        else if (error.request && !error.response) {
                            toast.error("⚠️ Network issue or server is unreachable. Try again later.")
                        }
                        else 
                        {
                            console.error("Unexpected error:", error);
                            toast.error("Something went wrong.");
                        }
        }
    }

    useEffect(() => {
        fetchAllCalendarHandbooks();
    }, []);

    const content = allCalendarHandbooks?.reports
        ?.filter(item => item.isActive)
        .map((item) => ({
            filename: item.filename,
            data: item.data,
            contentType: item.contentType,
        })) || [];

    return (
        <section className="calendarHandbookMainContainer">
            <header className="calendarHandBookHeader">
                <h2>Calendar Handbook</h2>
            </header>
            <DynamicDownloadBtnSection
                items={content}
                yearFontSize={1.25}
            />
        </section>
    )
}

export default CalendarHandbook
